'use client';

import * as React from 'react';
import * as ToggleGroupPrimitive from '@radix-ui/react-toggle-group';

import { cn } from '../../utils/cn/cn';
import { Label } from '../Label/Label';

const ToggleGroup = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Root> & {
    label?: string;
  }
>(({ className, children, label, id, ...props }, ref) => {
  const fallbackId = React.useId();
  return (
    <div className="inline-flex flex-col items-start">
      <Label htmlFor={id ?? fallbackId} className="text-size-body2 font-normal">
        {label}
      </Label>
      <ToggleGroupPrimitive.Root
        {...props}
        id={id ?? fallbackId}
        ref={ref}
        className={cn('flex items-center justify-center', className)}
      >
        {children}
      </ToggleGroupPrimitive.Root>
    </div>
  );
});

ToggleGroup.displayName = ToggleGroupPrimitive.Root.displayName;

const ToggleGroupItem = React.forwardRef<
  React.ElementRef<typeof ToggleGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof ToggleGroupPrimitive.Item>
>(({ className, children, ...props }, ref) => (
  <ToggleGroupPrimitive.Item
    ref={ref}
    className={cn(
      'toggle-group-item data-[disabled=false]:hover:bg-color-grey-light text-color-grey-dark data-[state=on]:bg-color-grey-light data-[disabled]:text-color-action-disabled data-[state=on]:text-color-text-dark border-color-grey border border-solid p-1.5 first:border-r-0 last:border-l-0',
      className,
    )}
    {...props}
  >
    {children}
  </ToggleGroupPrimitive.Item>
));

ToggleGroupItem.displayName = ToggleGroupPrimitive.Item.displayName;

export { ToggleGroup, ToggleGroupItem };
